import { useTranslation } from "react-i18next";

import { FilterButton, IOption } from "@digital-services/ui";
import { usePaginationContext } from "@ds-cps/ui";

import { relationshipOptions } from "@resource/models";
import { useGetResourcesRelationshipTypes } from "@resource/services/use-get-resources-relationship-types";

import { useResourcesContext } from "../context/useResourcesContext";

export const RelationshipTypeFilter = () => {
  const { relationshipFilter, setRelationshipFilter } = useResourcesContext();
  const { pageIndex, setPageIndex } = usePaginationContext();

  const { t } = useTranslation(undefined, {
    keyPrefix: "resources"
  });

  const { data } = useGetResourcesRelationshipTypes();

  const options = data?.length ? relationshipOptions(data) : [];

  return (
    <FilterButton
      data-testid="filter-by-relationship-type"
      singleFilter={true}
      options={options}
      selected={relationshipFilter ? [relationshipFilter] : []}
      onSelect={(options: IOption[]) => {
        if (options?.length) {
          setRelationshipFilter(options[0]);
        } else {
          setRelationshipFilter(null);
        }

        // This is to reset pagination when filtering by device type or state happens
        if (pageIndex !== 0) {
          setPageIndex(0);
        }
      }}
    >
      {relationshipFilter?.label || t("filters.byRelationshipType")}
    </FilterButton>
  );
};
